import React from 'react';

import { getLocationMaterialSymbol, getTriplegMaterialSymbol, MaterialSymbolIcon } from './materialSymbols';
import type { SemanticTypeOption, TriplegModeOption } from './timelineTypes';

export const SEMANTIC_TYPE_OPTIONS: SemanticTypeOption[] = [
  'unknown',
  'home',
  'my_home',
  'work',
  'my_office',
  'station',
  'transit',
  'cafe',
  'restaurant',
  'gym',
  'hospital',
  'school',
  'store',
  'hair_salon',
  'beauty_salon',
  'other',
];

export const SEMANTIC_TYPE_LABELS = new Map<string, string>([
  ['unknown', '未分類'],
  ['home', '家'],
  ['my_home', '自宅'],
  ['work', 'オフィス'],
  ['my_office', '自社オフィス'],
  ['station', '駅'],
  ['transit', '乗換'],
  ['cafe', 'カフェ'],
  ['restaurant', '飲食店'],
  ['gym', 'ジム'],
  ['hospital', '病院'],
  ['school', '学校'],
  ['store', '店舗'],
  ['hair_salon', 'ヘアサロン'],
  ['beauty_salon', 'エステサロン'],
  ['other', 'その他'],
]);

export const MANUAL_TRIPLEG_MODE_OPTIONS: Array<{ value: TriplegModeOption; label: string }> = [
  { value: 'walk', label: '徒歩' },
  { value: 'bicycle', label: '自転車' },
  { value: 'motorcycle', label: 'バイク' },
  { value: 'car', label: '自動車' },
  { value: 'taxi', label: 'タクシー' },
  { value: 'bus', label: 'バス' },
  { value: 'train', label: '電車' },
  { value: 'shinkansen', label: '新幹線' },
  { value: 'airplane', label: '航空機' },
];

export const TRIPLEG_MODE_LABELS = new Map<string, string>([
  ...MANUAL_TRIPLEG_MODE_OPTIONS.map((option) => [option.value, option.label] as const),
  ['slow_mobility', '低速移動'],
  ['motorized_mobility', '車両移動'],
  ['fast_mobility', '高速移動'],
  ['bike', '自転車'],
  ['air', '航空機'],
  ['unknown', '不明'],
]);

export const getSemanticTypeLabel = (value?: string | null) =>
  SEMANTIC_TYPE_LABELS.get(value || 'unknown') || value || '未分類';

export const getTriplegModeLabel = (value?: string | null) =>
  TRIPLEG_MODE_LABELS.get(value || 'unknown') || value || '不明';

export const SemanticTypeIcon: React.FC<{ semanticType?: string | null }> = ({ semanticType }) => {
  return <MaterialSymbolIcon symbol={getLocationMaterialSymbol(semanticType)} />;
};

export const TriplegModeIcon: React.FC<{ mode?: string | null }> = ({ mode }) => {
  return <MaterialSymbolIcon symbol={getTriplegMaterialSymbol(mode)} />;
};
